import React from "react";
import * as helpers from "../../../../helpers/helpers";

export default function TaxMoreFilters({ register, setValue, filterData }) {
  const taxOptions = helpers.getYearOptions([2024, 2023]);
  console.log(taxOptions, "taxOptions");
  return (
    <>
      <div className="col half_flex_form">
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Tax Year</h6>
          </div>
          <div className="half_flex">
            <div className="half_field">
              <select
                name="tax_min_year"
                id=""
                className="input"
                {...register("tax_min_year")}
              >
                <option value="">Min</option>
                {taxOptions?.map((taxYear, index) => {
                  return (
                    <option
                      value={taxYear?.value}
                      key={index}
                      selected={
                        filterData?.[`tax_min_year`] === taxYear?.value
                          ? true
                          : false
                      }
                    >
                      {taxYear?.label}
                    </option>
                  );
                })}
              </select>
            </div>
            <span></span>
            <div className="half_field">
              <select
                name="tax_max_year"
                id="tax_max_year"
                className="input"
                {...register("tax_max_year")}
                defaultValue={filterData?.tax_max_year}
              >
                <option value="">Max</option>
                {taxOptions?.map((taxYear, index) => {
                  return (
                    <option
                      value={taxYear?.value}
                      key={index}
                      selected={
                        filterData?.[`tax_max_year`] === taxYear?.value
                          ? true
                          : false
                      }
                    >
                      {taxYear?.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="br"></div>
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Tax amount</h6>
          </div>
          <div className="half_flex">
            <div className="half_field">
              <input
                type="number"
                name="min_tax_amount"
                className="input"
                placeholder="Min"
                {...register("min_tax_amount")}
                defaultValue={filterData?.min_tax_amount}
              />
            </div>
            <span></span>
            <div className="half_field">
              <input
                type="number"
                name="max_tax_amount"
                className="input"
                placeholder="Max"
                {...register("max_tax_amount")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
